import { Component, ViewChild } from '@angular/core';
import { NavController,  ViewController, Slides, ItemSliding, Item, AlertController, Searchbar, ActionSheetController,} from 'ionic-angular';

import { UserMyRadiant as User } from '../../../providers';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, OvertimeProvider, ApiMyRadiant} from '../../../providers';
import { Utility } from '../../../providers/resources/utility';
import { Calendar } from '@ionic-native/calendar';
import { ScreenOrientation } from '@ionic-native/screen-orientation';

@Component({
  selector: 'presensi-plan-overtime-bawahan',
  templateUrl: 'page.html'
})
export class PlanOvertimeBawahan {
  selectedDay = new Date()
  selectedObject
  data = {};
  viewTitle;
  isToday: boolean;
  
  constructor(public navCtrl: NavController,
    private actionSheetCtrl: ActionSheetController,
    private modalCtrl: ModalController,
    private screenOrientation : ScreenOrientation,
    ) {
      this.data = {"header":{"senin":"5","selasa":"6","rabu":"7","kamis":"8","jumat":"9","sabtu":"10","minggu":"11"},"data":[{"nama":"Muhammad","senin":"5","selasa":"6","rabu":"7","kamis":"8","jumat":"9","sabtu":"10","minggu":"11"},{"nama":"Dian","senin":"5","selasa":"6","rabu":"7","kamis":"8","jumat":"9","sabtu":"10","minggu":"11"},{"nama":"Mentari","senin":"5","selasa":"6","rabu":"7","kamis":"8","jumat":"9","sabtu":"10","minggu":"11"}]};
      console.log(this.data);
      // this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
    }

  loadEvents() {
    //this.eventSource = this.createRandomEvents();
  }
}



// WEBPACK FOOTER //
// ./src/pages/presensi/plan_overtime_bawahan/page.ts